import {
  NpcByItemAction,
  NpcByItemActionTypes,
  NpcByItemState
} from '../../types/npcByItem';

const initialState: NpcByItemState = {
  searchItems: [],
  byItem: {
    item: {
      id: null,
      sku: '',
      upc: '',
      mpn: '',
      brand: '',
      description: ''
    },
    profitCenters: [],
    markets: [],
    locationIds: [],
    locations: [],
    byMonth: [],
    total: {}
  },
  byItemConst: {
    markets: [],
    locations: [],
    getData: false
  },
  loading: false,
  searchLoading: true
};

export const npcByItemReducer = (
  state = initialState,
  action: NpcByItemAction
): NpcByItemState => {
  switch (action.type) {
    case NpcByItemActionTypes.SEARCH_NS_ITEMS:
      return {
        ...state,
        searchItems: action.payload,
        searchLoading: false
      };
    case NpcByItemActionTypes.SET_SEARCH_NS_ITEMS_LOADING:
      return {
        ...state,
        searchLoading: true
      };
    case NpcByItemActionTypes.GET_NPC_BY_ITEM:
      const { markets, locations } = action.payload;
      return {
        ...state,
        byItem: { ...state.byItem, ...action.payload },
        byItemConst: {
          ...state.byItemConst,
          markets: state.byItemConst.getData
            ? state.byItemConst.markets
            : markets
            ? markets
            : [],
          locations: state.byItemConst.getData
            ? state.byItemConst.locations
            : locations
            ? locations
            : [],
          getData: true
        },
        loading: false
      };
    case NpcByItemActionTypes.SET_NPC_BY_ITEM_LOADING:
      return {
        ...state,
        loading: true
      };
    case NpcByItemActionTypes.CLEAR_NPC_MARKETS:
      return {
        ...state,
        byItemConst: {
          markets: [],
          locations: [],
          getData: false
        }
      };
    case NpcByItemActionTypes.CLEAR_NPC_BY_ITEM:
      return initialState;
    default:
      return state;
  }
};
